<template>
  <div class="card-filter">
    <el-row
      type="flex"
      align="start"
      justify="space-between"
      class="flex-wrap mb-l"
    >
      <el-row
type="flex"
align="middle">
        <SelectOrg
          class="text-search mr-m"
        />
        <el-select
          v-model="objectType"
          size="small"
          class="w-100 mr-m"
          placeholder="Loại đối tượng"
          @change="searchNormal"
        >
          <el-option
            v-for="item in menus"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <el-input
          v-model="textSearch"
          class="text-search mr-m"
          size="small"
          placeholder="Nhập thông tin để tìm kiếm"
          clearable
        />
        <el-button
          size="small"
          type="primary"
          plain
          icon="el-icon-search"
          @click="searchNormal"
        >
          Tìm kiếm
        </el-button>
      </el-row>
    </el-row>
  </div>
</template>

<script>
import SelectOrg from "@/components/items/SelectOrg"
import CONSTANTS from "@/config/constants.js";

export default {
  name: "CardFilter",
  components: {
    SelectOrg
  },
  props: {
    type: String,
  },
  data() {
    return {
      textSearch: "",
      objectType: this.type,
      menus: [
        {
          label: "Tất cả",
          value: "",
        },
        ...CONSTANTS.OBJECT_TYPES,
      ],
    };
  },
  methods: {
    searchNormal() {
      this.$emit("search", {
        searchText: this.textSearch,
        type: this.objectType,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.card-filter {
  .text-search {
    min-width: 200px;
  }
}
</style>
